import { all, takeLatest } from 'redux-saga/effects'

import {
  fetchActiveCareEnrolments,
  fetchActiveCareLinks,
  fetchInstallmentOrders,
  fetchOrders,
  fetchPlayCareTransactions
} from 'api/orders'
import constants from 'app/constants'
import * as types from 'app/store/types/ordersEntity'

import { handleFetch } from './saga.helper'

import {
  fetchActiveCareLinksData,
  fetchActiveCareLinksDataSuccess,
  fetchOrdersData,
  fetchOrdersDataSuccess,
  fetchPlayCareTransactionsData,
  fetchPlayCareTransactionsDataSuccess,
  fetchInstallmentOrdersData,
  fetchInstallmentOrdersDataSuccess
} from '../actions/ordersEntity'

const mapping = {
  [constants.ORDERS]: {
    api: {
      fetch: fetchOrders
    },
    action: {
      fetch: fetchOrdersData,
      fetchSuccess: fetchOrdersDataSuccess
    }
  },
  [constants.PLAY_CARE_ORDERS]: {
    api: {
      fetch: fetchPlayCareTransactions
    },
    action: {
      fetch: fetchPlayCareTransactionsData,
      fetchSuccess: fetchPlayCareTransactionsDataSuccess
    }
  },
  [constants.INSTALLMENT_ORDERS]: {
    api: {
      fetch: fetchInstallmentOrders
    },
    action: {
      fetch: fetchInstallmentOrdersData,
      fetchSuccess: fetchInstallmentOrdersDataSuccess
    }
  },
  [constants.ACTIVE_CARE_ORDERS]: {
    api: {
      fetch: fetchActiveCareLinks
    },
    action: {
      fetch: fetchActiveCareLinksData,
      fetchSuccess: fetchActiveCareLinksDataSuccess
    }
  },
  [constants.ACTIVE_CARE_ENROLMENTS]: {
    api: {
      fetch: fetchActiveCareEnrolments
    },
    action: {
      fetch: fetchActiveCareLinksData,
      fetchSuccess: fetchActiveCareLinksDataSuccess
    }
  }
}

export function* _fetchOrdersEntity({ queries, entity } = {}) {
  const mappingData = mapping[entity]
  yield handleFetch(mappingData, queries, entity)
}

// One takeLatest per list: Orders > Active Care loads two lists at once, and
// a single takeLatest over every type let the second fetch cancel the first.
// Each list still drops its own stale fetch when a filter changes.
export function* watchFetchOrdersEntity() {
  yield all(
    [
      types.FETCH_ORDERS_DATA,
      types.FETCH_PLAY_CARE_TRANSACTIONS_DATA,
      types.FETCH_INSTALLMENT_ORDERS_DATA,
      types.FETCH_ACTIVE_CARE_LINKS_DATA
    ].map((type) => takeLatest(type, _fetchOrdersEntity))
  )
}
